module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat#4-b37d4313d29e47a7dc1f6644abeffc5a.svg";